import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../../../services/auth/auth.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {LoaderService} from '../../../../services/loader/loader.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {GuestComponent} from '../../../layout/guest/guest.component';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    RouterLink,
    GuestComponent,
  ],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss'
})
@MetaTitle('Login')
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    rememberMe: new FormControl(false)
  })

  redirectUrl: string = '/';

  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    /**
     * Login via impersonation
     */
    const params = new URLSearchParams(document.location.search);
    const paramToken = params.get('token');
    const paramExpireAt = params.get('expireAt');
    if (paramToken && paramExpireAt) {
      this.auth.setBearer(paramToken, new Date(paramExpireAt));
      this.router.navigate(['/']).then();
      return;
    }

    /**
     * Manual login
     */
    if (this.auth.isLogged()) {
      this.router.navigateByUrl('/').then();
    }

    this.route.queryParams.subscribe((params) => {
      this.redirectUrl = params['redirect'] ?? '/';
    });

    if (this.auth.isStoredSession()) {
      this.loginForm.get('rememberMe')?.patchValue(true);
    }

    this.loader.stopLoading();
  }

  onSubmit(): void {
    if (!this.loginForm.value.email || !this.loginForm.value.password) {
      return;
    }

    this.loader.startLoading();

    this.auth.login(
      this.loginForm.value.email,
      this.loginForm.value.password,
      this.loginForm.value.rememberMe ?? true
    ).subscribe({
      next: (): void => {
        this.loader.stopLoading();
        this.router.navigateByUrl(this.redirectUrl).then();
      },
      error: (error): void => {
        console.log(error);
        this.loader.stopLoading();
        this.snackbar.error(error, null, 3000);
      }
    });
  }
}
